import axios from 'axios'
import api from '@/api/poi-detail'
import { basicInfoToAllData, formatPoiReviewData, formatRestaurantData, formatPoiFence, formatFacilityReviewData } from './static'

const basicInfo = {
  axiosToken: null,
  data: null,
  loading: true,
  error: false
}

const historystate = {
  axiosToken: null,
  dataList: [],
  loading: true,
  error: false
}

const fuelDefPrice = {
  axiosToken: null,
  data: null,
  loading: true,
  error: false
}

const ratingState = {
  axiosToken: null,
  data: null,
  loading: true,
  error: false
}

const reviewState = {
  axiosToken: null,
  data: null,
  loading: true,
  error: false
}

const restaurantState = {
  axiosToken: null,
  data: null,
  loading: true,
  error: false
}

const poiFence = {
  axiosToken: null,
  data: null,
  loading: true,
  error: false
}

const initState = {
  allData: '',
  basicInfo: basicInfo,
  historystate: historystate,
  fuelDefPrice: fuelDefPrice,
  ratingState: ratingState,
  reviewState: reviewState,
  restaurantState: restaurantState,
  poiFence: poiFence
}

const CancelToken = axios.CancelToken

export default {
  namespaced: true,
  state: Object.assign({}, initState),
  mutations: {
    INIT_DETAIL(state) {
      Object.keys(state).forEach(item => {
        if (Object.hasOwnProperty.call(initState, item)) {
          if (Object.prototype.toString.call(initState[item]) === '[object Object]' && state[item].axiosToken) {
            state[item] = Object.assign({}, initState[item], { axiosToken: state[item].axiosToken })
          } else {
            state[item] = initState[item]
          }
        } else {
          state[item] = null
        }
      })
    },
    SET_ALL_DATA(state, data) {
      state.allData = state.allData ? Object.assign({}, state.allData, data) : data
    },
    SET_BASIC_INFO(state, data) {
      state.basicInfo = Object.assign({}, basicInfo, {
        data: data,
        loading: false,
        error: false
      })
    },
    SET_BASIC_INFO_AXIOS_TOKEN(state, token) {
      state.basicInfo = Object.assign({}, state.basicInfo, { axiosToken: token })
    },
    SET_BASIC_INFO_ERROR(state) {
      state.basicInfo = Object.assign({}, basicInfo, {
        data: null,
        loading: false,
        error: true
      })
    },
    SET_HISTORY_STATE(state, data) {
      state.historystate = Object.assign({}, historystate, {
        dataList: data,
        loading: false,
        error: false
      })
    },
    SET_HISTORY_STATE_AXIOS_TOKEN(state, token) {
      state.historystate = Object.assign({}, state.historystate, { axiosToken: token })
    },
    SET_HISTORY_STATE_ERROR(state) {
      state.historystate = Object.assign({}, historystate, {
        dataList: [],
        loading: false,
        error: true
      })
    },
    SET_FUEL_DEF_PRICE(state, data) {
      state.fuelDefPrice = Object.assign({}, fuelDefPrice, {
        data: data,
        loading: false,
        error: false
      })
    },
    SET_FUEL_DEF_PRICE_AXIOS_TOKEN(state, token) {
      state.fuelDefPrice = Object.assign({}, state.fuelDefPrice, { axiosToken: token })
    },
    SET_FUEL_DEF_PRICE_ERROR(state) {
      state.fuelDefPrice = Object.assign({}, fuelDefPrice, {
        data: null,
        loading: false,
        error: true
      })
    },
    SET_RATING_STATE(state, data) {
      state.ratingState = Object.assign({}, ratingState, {
        data: data,
        loading: false,
        error: false
      })
    },
    SET_RATING_STATE_AXIOS_TOKEN(state, token) {
      state.ratingState = Object.assign({}, state.ratingState, { axiosToken: token })
    },
    SET_RATING_STATE_ERROR(state) {
      state.ratingState = Object.assign({}, ratingState, {
        data: null,
        loading: false,
        error: true
      })
    },
    SET_REVIEW_STATE(state, data) {
      state.reviewState = Object.assign({}, reviewState, {
        data: data,
        loading: false,
        error: false
      })
    },
    SET_REVIEW_STATE_AXIOS_TOKEN(state, token) {
      state.reviewState = Object.assign({}, state.reviewState, { axiosToken: token })
    },
    SET_REVIEW_STATE_ERROR(state) {
      state.reviewState = Object.assign({}, reviewState, {
        data: null,
        loading: false,
        error: true
      })
    },
    SET_RESTAURANT_STATE(state, data) {
      state.restaurantState = Object.assign({}, restaurantState, {
        data: data,
        loading: false,
        error: false
      })
    },
    SET_RESTAURANT_STATE_AXIOS_TOKEN(state, token) {
      state.restaurantState = Object.assign({}, state.restaurantState, { axiosToken: token })
    },
    SET_RESTAURANT_STATE_ERROR(state) {
      state.restaurantState = Object.assign({}, restaurantState, {
        data: null,
        loading: false,
        error: true
      })
    },
    SET_POI_FENCE(state, data) {
      state.poiFence = Object.assign({}, poiFence, {
        data: data,
        loading: false,
        error: false
      })
    },
    SET_POI_FENCE_AXIOS_TOKEN(state, token) {
      state.poiFence = Object.assign({}, state.poiFence, { axiosToken: token })
    },
    SET_POI_FENCE_ERROR(state) {
      state.poiFence = Object.assign({}, poiFence, {
        data: null,
        loading: false,
        error: true
      })
    }
  },
  actions: {
    initDetail({ commit }) {
      commit('INIT_DETAIL')
    },
    getBasicInfo({ commit, state }, ident) {
      if (state.basicInfo.axiosToken) state.basicInfo.axiosToken.cancel('cancel request')
      let source = CancelToken.source()
      commit('SET_BASIC_INFO_AXIOS_TOKEN', source)
      return api.getStaticData({ id: ident }, source.token).then(({ res }) => {
        commit('SET_BASIC_INFO', res.data)
        commit('SET_ALL_DATA', basicInfoToAllData(res.data))
      }).catch(({ error }) => {
        if (error && error.message === 'cancel request') return null
        commit('SET_BASIC_INFO_ERROR')
      })
    },
    getPlanTwoHistory({ commit, state }, ident) {
      if (state.historystate.axiosToken) state.historystate.axiosToken.cancel('cancel request')
      let source = CancelToken.source()
      commit('SET_HISTORY_STATE_AXIOS_TOKEN', source)
      return api.getPlanTripHistory(ident, source.token).then(({ res }) => {
        commit('SET_HISTORY_STATE', res.data.results)
      }).catch(({ error }) => {
        if (error && error.message === 'cancel request') return null
        commit('SET_HISTORY_STATE_ERROR')
      })
    },
    getFuelDefPrice({ commit, state }, ident) {
      if (state.fuelDefPrice.axiosToken) state.fuelDefPrice.axiosToken.cancel('cancel request')
      let source = CancelToken.source()
      commit('SET_FUEL_DEF_PRICE_AXIOS_TOKEN', source)
      return api.getPlanTripFuel({ id: [ident] }, source.token).then(({ res }) => {
        let fuelPrice = ''
        let defPrice = ''
        let _info = {}
        try {
          let fuelPrices = res.data.data.fuelPrices
          _info = fuelPrices[0]
          fuelPrice = _info.fuelPrice !== null ? _info.fuelPrice.toFixed(3) : ''
          defPrice = _info.defPrice !== null ? _info.defPrice.toFixed(3) : ''
        } catch {
          fuelPrice = ''
          defPrice = ''
          _info = {}
        }
        commit('SET_FUEL_DEF_PRICE', { ..._info, fuelPrice, defPrice })
      }).catch(({ error }) => {
        if (error && error.message === 'cancel request') return null
        commit('SET_FUEL_DEF_PRICE_ERROR')
      })
    },
    getRatingState({ commit, state }, ident) {
      if (state.ratingState.axiosToken) state.ratingState.axiosToken.cancel('cancel request')
      let source = CancelToken.source()
      commit('SET_RATING_STATE_AXIOS_TOKEN', source)
      return api.getPlanTripNumber({ id: ident }, source.token).then(({ res }) => {
        let data = { rating: res.data.data.rating, reviewNum: res.data.data.review_num }
        commit('SET_RATING_STATE', data)
        commit('SET_ALL_DATA', data)
      }).catch(({ error }) => {
        if (error && error.message === 'cancel request') return null
        commit('SET_RATING_STATE_ERROR')
      })
    },
    getReviewState({ commit, state }, payload) {
      let params = {
        id: payload.ident,
        sort: payload.sort,
        before: payload.before,
        limitReviews: 3
      }
      if (state.reviewState.axiosToken) state.reviewState.axiosToken.cancel('cancel request')
      let source = CancelToken.source()
      commit('SET_REVIEW_STATE_AXIOS_TOKEN', source)
      return api.getPlanTripReview(params, source.token).then(({ res }) => {
        let data = {
          history: res.data.results,
          reviewsData: formatPoiReviewData(res.data.results)
        }
        commit('SET_REVIEW_STATE', res.data)
        commit('SET_ALL_DATA', data)
      }).catch(({ error }) => {
        if (error && error.message === 'cancel request') return null
        commit('SET_REVIEW_STATE_ERROR')
      })
    },
    getRestaurantState({ commit, state }, payload) {
      let params = {
        latitude: payload.latitude,
        longitude: payload.longitude,
        limitRest: 2
      }
      if (state.restaurantState.axiosToken) state.restaurantState.axiosToken.cancel('cancel request')
      let source = CancelToken.source()
      commit('SET_RESTAURANT_STATE_AXIOS_TOKEN', source)
      return api.getPlanTripRest(params, source.token).then(({ res }) => {
        let restArr = []
        if (res.data.businesses && res.data.businesses.length) {
          restArr = formatRestaurantData(res.data.businesses.slice(0, 2))
        }
        let data = {
          totalRest: res.data.total,
          restList: restArr
        }
        commit('SET_RESTAURANT_STATE', res.data)
        commit('SET_ALL_DATA', data)
      }).catch(({ error }) => {
        if (error && error.message === 'cancel request') return null
        commit('SET_RESTAURANT_STATE_ERROR')
      })
    },
    getPoiFenceState({ commit, state }, ident) {
      if (state.poiFence.axiosToken) state.poiFence.axiosToken.cancel('cancel request')
      let source = CancelToken.source()
      commit('SET_POI_FENCE_AXIOS_TOKEN', source)
      return api.getPoiFence(ident, source.token).then(({ res }) => {
        let extensionInfo = formatPoiFence(res.data.data)
        let data = {
          extensionInfo: extensionInfo,
          bbox: extensionInfo.bbox || []
        }
        commit('SET_POI_FENCE', res.data.data)
        commit('SET_ALL_DATA', data)
        return data
      }).catch(({ error }) => {
        if (error && error.message === 'cancel request') return null
        commit('SET_POI_FENCE_ERROR')
      })
    },
    getPoiReview(context, params) {
      return api.getPlanTripReview(params).then(({ res }) => {
        return {
          list: formatPoiReviewData(res.data.results),
          total: res.data.total_size,
          totalPage: res.data.total_page,
          currentPage: res.data.page,
          error: false
        }
      }).catch(error => {
        console.log(error)
        return {
          error: true,
          list: []
        }
      })
    },
    getFacilityReview(content, params) {
      return api.getFacilityReview(params).then(({ res }) => {
        let data = res.data.data
        return {
          list: formatFacilityReviewData(data.reviewList),
          total: data.count,
          totalPage: data.totalPage,
          currentPage: data.curPage,
          error: false
        }
      }).catch(error => {
        console.log(error)
        return {
          error: true,
          list: []
        }
      })
    },
    getPointRestaurant(content, params) {
      return api.getPlanTripRest(params).then(({ res }) => {
        let data = res.data
        return {
          list: formatRestaurantData(data.businesses),
          total: data.total,
          error: false
        }
      }).catch(error => {
        console.log(error)
        return {
          error: true,
          list: [] 
        }
      })
    },
    getPoiFence(content, poiId) {
      return api.getPoiFence(poiId).then(({ res }) => {
        return Object.assign(formatPoiFence(res), { ident: poiId })
      }).catch(error => {
        console.log(error)
        return { ident: poiId }
      })
    }
  }
}